export default {
  translation: {
    nav: {
      home: 'Início',
      trips: 'Viagens',
      aboutUs: 'Sobre nós',
      alerts: 'Alertas',
      wishlist: 'Favoritos',
      language: 'Idioma',
      profile: 'Perfil',
      settings: 'Configurações',
      signIn: 'Entrar',
      signUp: 'Cadastrar'
    },
    hero: {
      title: 'Explore Uganda',
      subtitle: 'e além',
      description: 'Descubra a Pérola da África com guias locais especializados. Experiências inesquecíveis aguardam você nas paisagens deslumbrantes e na cultura vibrante de Uganda.',
      searchPlaceholder: 'Para onde você quer ir?',
      categories: {
        all: 'Todos',
        wildlife: 'Vida Selvagem',
        safari: 'Safari',
        cultural: 'Cultural',
        adventure: 'Aventura',
        birding: 'Observação de Aves'
      }
    },
    common: {
      from: 'a partir de',
      reviews: 'avaliações',
      viewMore: 'Ver mais',
      book: 'Reservar',
      seeAll: 'Ver tudo',
      loading: 'Carregando...'
    }
  }
};